import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "progressbar" }
const _hoisted_2 = {
  key: 0,
  class: "progress-label"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["ProgressBar"], {
      pt: $setup.pt,
      value: $props.value
    }, null, 8 /* PROPS */, ["value"]),
    (!$props.error && $props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString($setup.c_val) + _toDisplayString($props.symb), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}